import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Header from "../../component/header";
import Footer from "../../component/footer";
const base_Url = process.env.REACT_APP_API_URL;

const BlogDetail = () => {
  const { id } = useParams();
  const [blogData, setBlogData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBlogDetail = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${base_Url}/Blog/${id}`);
        if (!response.ok) {
          throw new Error(`Failed to load blog post (${response.status})`);
        }
        const data = await response.json();
        
        if (data.status?.code === 1 || data.Status?.Code === 1) {
          const blogItem = data.data?.[0] || data.Data?.[0] || data.data || data.Data;
          setBlogData(blogItem);
        } else if (data && !data.status && !data.Status) {
          setBlogData(data);
        } else {
          throw new Error(data.status?.message || data.Status?.Message || 'Blog post not found');
        }
      } catch (err) {
        console.error('Blog detail fetch error:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogDetail();
  }, [id]);

  if (loading) {
    return (
      <div className="App">
        <Header />
        <div className="container text-center py-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  if (error) {
    return (
      <div className="App">
        <Header />
        <div className="container text-center py-5">
          <div className="alert alert-danger" role="alert">
            Error loading blog post: {error}
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  if (!blogData) {
    return (
      <div className="App">
        <Header />
        <div className="container text-center py-5">
          <div className="alert alert-warning" role="alert">
            Blog post not found
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="App">
      <Header />
      <div className="container my-5">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <h1 className="mb-4">{blogData.title}</h1>
            <img 
              src={blogData.imageUrl} 
              alt={blogData.title} 
              className="img-fluid rounded mb-4"
            />
            <div 
              dangerouslySetInnerHTML={{ __html: blogData.article }} 
              className="blog-content"
            />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default BlogDetail;